import { useUser } from 'app/utils/useUser'

export const useUserName = () => {
  const { profile$, session } = useUser()
  return profile$.name.get() ?? session?.user.user_metadata.name ?? '-'
}
